<template>
  <div class="banner-container" :class="color">
    <div class="banner-top">
      <div class="banner-view">
        <div class="banner-icon">
          <img id="banner-icon-img" :src="iconType" :alt="iconType" />
        </div>
        <div class="banner-slot">
          <slot></slot>
        </div>
      </div>
      <div class="banner-button" v-if="comments || additionalInfo">
        <v-button class="small subtle" :class="color" @click="toggle">
          <img v-if="!isCollapsed" :src="plusIcon" alt="Plus icon" />
          {{ isCollapsed ? "Collapse" : buttonTitle }}
        </v-button>
      </div>
    </div>
    <div class="banner-bottom">
      <div
        class="banner-rejected-info"
        v-if="comments && isCollapsed"
        alt="comments"
      >
        <p v-html="comments" />
      </div>
      <div
        class="banner-rejected-info"
        v-if="additionalInfo && isCollapsed"
        alt="additional information"
      >
        <p>{{ additionalInfo }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import VButton from "./VButton.vue";
import infoIcon from "../../images/white-info.svg";
import triAlertIcon from "../../images/white-alert.svg";
import checkIcon from "../../images/white-check.svg";
import crclAlertIcon from "../../images/white-warning.svg";
import plus from "../../images/white-plus.svg";

export default {
  components: {
    VButton,
  },
  props: {
    comments: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      required: true,
    },
    buttonTitle: {
      type: String,
      default: "Why?",
    },
    additionalInfo: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isCollapsed: false,
      iconType: null,
      plusIcon: plus,
    };
  },
  methods: {
    toggle() {
      this.isCollapsed = !this.isCollapsed;
    },
    getIconType() {
      if (this.color === "warning") {
        this.iconType = crclAlertIcon;
      } else if (this.color === "info") {
        this.iconType = infoIcon;
      } else if (this.color === "errorRed") {
        this.iconType = triAlertIcon;
      } else if (this.color === "success") {
        this.iconType = checkIcon;
      } else {
        return this.iconType;
      }
    },
  },
  mounted() {
    this.getIconType();
  },
};
</script>

<style scoped>
.banner-container {
  container-type: inline-size;
  color: white;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 2px;
  margin: 0.5rem 0;
}
.banner-view {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.banner-top {
  display: flex;
  flex-direction: row;
}
@container (width < 300px) {
  .banner-top {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .scishield-button.small {
    font-size: var(--font-size-50, 0.79rem);
    height: 1.5rem;
    padding: 0 1rem;
  }
}
.banner-button {
  display: flex;
  align-items: center;
  margin: auto;
}
.banner-container.warning {
  background-color: var(--yellow-900);
}
.banner-container.info {
  background-color: var(--blue-900);
}
.banner-container.errorRed {
  background-color: var(--red-900);
}
.banner-container.success {
  background-color: var(--green-900);
}
.banner-icon {
  flex: 1;
}
</style>
